import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDish, getIsFetching } from '../selectors';
import { fetchDish } from '../actions';
import { toJS } from '../../../utils/immutableUtils';

const useDish = (formulaCode, { forceFetch = false } = {}) => {
  const [isMounted, setIsMounted] = useState(false);
  const dispatch = useDispatch();
  const dish = useSelector(getDish(formulaCode));
  const isFetching = useSelector(getIsFetching);
  const isDishNotLoaded = !dish;

  useEffect(() => {
    if (isMounted) {
      return;
    }
    if (forceFetch || isDishNotLoaded) {
      dispatch(fetchDish(formulaCode));
    }
    setIsMounted(true);
  }, [formulaCode, forceFetch, dispatch, isDishNotLoaded, isMounted]);

  return [toJS(dish), isFetching];
};

export default useDish;
